import { SAVE_I140FORMS_SUCCESS,SAVE_I140FORMS_FAILED , SAVE_I140FORMS_STARTED,
  UPDATE_I140FORMS_SUCCESS,UPDATE_I140FORMS_FAILED ,UPDATE_I140FORMS_STARTED,
  GET_I140FORMS_STARTED,GET_I140FORMS_SUCCESS,GET_I140FORMS_FAILED,
  SAVEPDF_I140FORMS_STARTED, SAVEPDF_I140FORMS_SUCCESS,SAVEPDF_I140FORMS_FAILED,
  EXTRACT_ETA9089_STARTED, EXTRACT_ETA9089_SUCCESS, EXTRACT_ETA9089_FAILED, EXTRACT_ETA9089_RESET,
  GET_ETA9089_STARTED, GET_ETA9089_SUCCESS, GET_ETA9089_FAILED,
  UPDATE_ETA9089_STARTED, UPDATE_ETA9089_SUCCESS, UPDATE_ETA9089_FAILED,
 } from '../actions/VisaCareI140Case';

  
const intialData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};

export const i140FormPdfData = (state = intialData, action: any) => {

  switch (action.type) {
    case SAVEPDF_I140FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVEPDF_I140FORMS_SUCCESS:
      return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVEPDF_I140FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    
    default:
        return state;
    }
    
}
export const visaCareI140FormData = (state = intialData, action: any) => {
  switch (action.type) {
    case SAVE_I140FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVE_I140FORMS_SUCCESS:
    if(action.payload.id===undefined || action.payload.id==="" || action.payload.id===null){
      action.payload="Error Occurs in Input. Pls try Again...";
      alert("Error Occurs in Input. Pls try Again...");
    }else{
      alert("I140Form Data Inserted Successfully... ");
    }
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVE_I140FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    case UPDATE_I140FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_I140FORMS_SUCCESS: 
  /*  if(action.payload.id===undefined || action.payload.id==="" || action.payload.id===null){
      action.payload="Error Occurs in Input. Pls try Again...";
      alert("Error Occurs in Input. Pls try Again...");
    }else{
      alert("I140Form Data Updated Successfully... ");
    }*/
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_I140FORMS_FAILED:
    return {
      ...state,
      isLoading: true 
    };
    case GET_I140FORMS_STARTED:  
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_I140FORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_I140FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    default:
        return state;
    }

}

// ETA-9089 upload <-> JSON, one slice for the three eta9089 calls:
//   extract (read the PDF), get (stored JSON), update (save edited JSON).
// operation says which call this state is about; items is the server
// response { id, caseId, fileUploadId, ..., eta9089Form }.
const eta9089ExtractInitial = {
    isLoading: false,
    operation: "",
    fileUploadId: null,
    items: null,
    error: ""
};

export const eta9089ExtractData = (state = eta9089ExtractInitial, action: any) => {
  switch (action.type) {
    case EXTRACT_ETA9089_STARTED:
    case GET_ETA9089_STARTED:
    case UPDATE_ETA9089_STARTED:
      return {
        ...state,
        isLoading: true,
        operation: action.type === EXTRACT_ETA9089_STARTED ? "extract" : action.type === GET_ETA9089_STARTED ? "get" : "update",
        fileUploadId: action.input,
        error: ""
      };
    case EXTRACT_ETA9089_SUCCESS:
    case GET_ETA9089_SUCCESS:
    case UPDATE_ETA9089_SUCCESS:
      return {
        ...state,
        isLoading: false,
        fileUploadId: action.input,
        items: action.payload,
        error: ""
      };
    case EXTRACT_ETA9089_FAILED:
    case GET_ETA9089_FAILED:
    case UPDATE_ETA9089_FAILED:
      return {
        ...state,
        isLoading: false,
        fileUploadId: action.input,
        error: action.payload
      };
    case EXTRACT_ETA9089_RESET:
      return eta9089ExtractInitial;
    default:
      return state;
  }
}
